import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { CardHeader } from "shards-react";

const CustomizedCardHeader = props => {
    const { initialName, className, menuList, children } = props;
    return (
        <CardHeader
            className={className}
            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
            }}
        >
            <div style={{ flexGrow: 10 }}>{initialName}</div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    flexGrow: 1
                }}
            >
                {menuList &&
                    menuList.map((menu, index) => {
                        return menu.showLink ? (
                            <Link key={`${menu.label}-${index}`} to={menu.path}>
                                {menu.label}
                            </Link>
                        ) : (
                            <span key={`${menu.label}-${index}`}>
                                {menu.label}
                            </span>
                        );
                    })}
            </div>
            {children}
        </CardHeader>
    );
};

CustomizedCardHeader.propTypes = {
    initialName: PropTypes.string,
    className: PropTypes.string,
    menuList: PropTypes.array,
    children: PropTypes.element
};

export default CustomizedCardHeader;
